$ ->

  $(document).on "click", "[data-change-currency]", ->
    $('#change_currency').modal();
